import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { MetaPixel } from './components/MetaPixel';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-amber/25" data-id="element-0" data-mp="23t8h0dnsuhcx">
      <MetaPixel data-id="element-1" data-mp="3ii4ppvcl6gle" />
      <AnnouncementBar data-id="element-2" data-mp="3mlatmwc87vop" />
      <main data-id="element-3" data-mp="3mkhmvvd9p66k">
        <HeroSection data-id="element-4" data-mp="3mjzsz5e2v41t" />
        <StatsBar data-id="element-5" data-mp="3mjg8bgx1m1k3" />
        <TransformationSection data-id="element-6" data-mp="3rc9dg5wfbbwp" />
        <PainPointsSection data-id="element-7" data-mp="3rbzpsoyupgu6" />
        <KitContentsSection data-id="element-8" data-mp="3rcsuzli5vya7" />
        <InstantAccessSection data-id="element-9" data-mp="5yk6vxnnffx" />
        <BonusesSection data-id="element-10" data-mp="67yvnd9206b" />
        <PricingSection data-id="element-11" data-mp="5gez9t0lqvv" />
        <GuaranteeSection data-id="element-12" data-mp="82j0zgp5o9c" />
        <TestimonialsSection data-id="element-13" data-mp="2zld259q0hfbj" />
        <FAQSection data-id="element-14" data-mp="2zm4v0cs84yy4" />
        <FinalCTASection data-id="element-15" data-mp="2zmwi0z7r9ocs" />
      </main>
      <Footer data-id="element-16" data-mp="33mf3bw3ho1g5" />
    </div>;
}